import React, { FC } from 'react'
import { Trans } from '@lingui/macro'

import { CampaignFilterInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import UserList from '../user/user-list/UserList'
import Loader from '../loader/Loader'
import { prepareCampaignFilterForUpsert } from '../../../pages/manage-campaign-page/components/SaveFiltersButton'
import {
  usePreviewCampaignAudienceCheckQuery,
  usePreviewDashboardAudienceCheckQuery
} from './AudienceCheckPreview.codegen'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const renderUsers = (dryAudienceCheckResult) => {
  if (!dryAudienceCheckResult) {
    return null
  }
  const { joinUsers, leaveUsers } = dryAudienceCheckResult
  if (joinUsers.length === 0 && leaveUsers.length === 0) {
    return (
      <h4>
        <Trans>There will be no changes to the audience</Trans>
      </h4>
    )
  }
  return (
    <>
      {joinUsers.length > 0 && (
        <>
          <h3>
            <Trans>Users who will join:</Trans>
          </h3>
          <UserList users={joinUsers} />
        </>
      )}
      {leaveUsers.length > 0 && (
        <>
          <h3>
            <Trans>Users who will leave:</Trans>
          </h3>
          <UserList users={leaveUsers} />
        </>
      )}
    </>
  )
}

export const CampaignAudienceCheckPreview: FC<{
  campaignId: number
  filters: CampaignFilterInput[]
}> = ({ filters, campaignId }) => {
  const { session } = usePublicApiSession()
  const { data } = usePreviewCampaignAudienceCheckQuery({
    variables: {
      filters: filters.map((filter) =>
        prepareCampaignFilterForUpsert(filter, session?.user.id)
      ),
      campaignId
    }
  })
  if (!data) {
    return <Loader />
  }

  return renderUsers(data.admin?.campaign?.dryAudienceCheck)
}

export const DashboardAudienceCheckPreview: FC<{
  dashboardId: number
  filters: CampaignFilterInput[]
}> = ({ filters, dashboardId }) => {
  const { session } = usePublicApiSession()
  const { data } = usePreviewDashboardAudienceCheckQuery({
    variables: {
      filters: filters.map((filter) =>
        prepareCampaignFilterForUpsert(filter, session?.user.id)
      ),
      dashboardId
    }
  })
  if (!data) {
    return <Loader />
  }

  return renderUsers(data.admin?.dashboard?.dryAudienceCheck)
}
